import { FC } from 'react';
import styled from 'styled-components';
import { Divider, Stack } from '@mui/material';
import HomeHeader from './header/HomeHeader';
import Insights from './insights/Insights';
import Posts from './posts/Posts';

const Container = styled(Stack)`
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: ${({ theme }) => theme.spacing(4, 4, 0)};
  overflow: auto;
`;

const ContentWrapper = styled(Stack)`
  padding-top: ${({ theme }) => theme.spacing(3)};
  overflow: auto;
  height: 100%;
  align-items: center;
`;

const Body = styled(Stack)`
  width: 100%;
  max-width: 670px;
`;

const HomeView: FC = () => (
  <Container>
    <HomeHeader />
    <Divider />
    <ContentWrapper>
      <Body>
        <Insights />
        <Posts />
      </Body>
    </ContentWrapper>
  </Container>
);

export default HomeView;
